import { render, staticRenderFns } from "./CompanyValuation.vue?vue&type=template&id=2435f443&"
import script from "./CompanyValuation.vue?vue&type=script&lang=ts&"
export * from "./CompanyValuation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports